import React from 'react';

// Wave 42.378 — persistent reminder that you're on the UAT/sandbox build,
// not production. REACT_APP_ENV is set to 'uat' only in .env.uat.
const IS_UAT = process.env.REACT_APP_ENV === 'uat';

const SandboxBanner = () => {
  if (!IS_UAT) return null;
  return (
    <div
      role="status"
      data-testid="sandbox-banner"
      className="fixed top-0 left-0 right-0 z-[9998] h-8 bg-purple-800 text-purple-50 px-4 flex items-center justify-center gap-2 text-xs font-semibold tracking-wide shadow-md"
    >
      🧪 SANDBOX — this is the UAT test environment, not production
    </div>
  );
};

export default SandboxBanner;
